import { useQuery } from 'react-query';
import { getTenantMymeCategoriesAPI } from '@myme/api';
import { getTenantMymeCategories } from '@myme/logic';

export const useGetTenantCategories = () => {
  const { data, isSuccess, isFetching } = useQuery(
    getTenantMymeCategoriesAPI.cacheKeys,
    async () => {
      const { data } = await getTenantMymeCategories();

      return data;
    },
    {
      cacheTime: 30000
    }
  );

  return { tenantCategories: data, isCategoriesSuccess: isSuccess, isCategoriesFetching: isFetching };
};
